import PaymentAdd from "./components/PaymentAdd";
export default PaymentAdd;
